import * as aTypes from '../../action-types'
import * as mTypes from '../../mutation-types'
import api from '../../../api'

const state = {
  notFound: false,
  loaded: false,
  id: '',
  name: '',
  mobile: '',
  tickets: {},
  sessionTimes: [],
  formData: [],
  adminComment: ''
}

const actions = {
  [aTypes.ACTIVITY_GET_SIGN_UP] ({ commit, state }, { activityId, number }) {
    return new Promise((resolve, reject) => {
      commit(mTypes.SET_LOADING, { key: aTypes.ACTIVITY_GET_SIGN_UP, loading: true })
      api.activity.getSignUp({
        success: resolve,
        fail: reject,
        commit
      }, { activityId, number })
    }).then(res => {
      const signUps = []
      if (!(res.body instanceof Array) || (res.body instanceof Array && res.body.length === 0)) {
        commit(mTypes.ACTIVITY_SET_SIGN_UPS, { signUpCount: 0, signUps: [] })

        return true
      }
      for (let i = 0; i < res.body.length; i++) {
        const signUp = res.body[i]
        signUps.push({
          id: signUp.sign_up.id,
          signInCode: signUp.signInCode,
          mobile: signUp.sign_up.mobile,
          name: signUp.sign_up.name,
          adminComment: signUp.sign_up.admin_comment,
          tickets: signUp.tickets,
          sessionTimes: signUp.session_times,
          formData: signUp.form_data
        })
      }

      commit(mTypes.ACTIVITY_SET_SIGN_UPS, { signUpCount: signUps.length, signUps: signUps })

      return true
    })
  },
  [aTypes.ACTIVITY_POST_SIGNIN] ({ commit }, { activityId, signUpId, body }) {
    return new Promise((resolve) => {
      commit(mTypes.SET_LOADING, { key: aTypes.ACTIVITY_POST_SIGNIN, loading: true })
      api.activity.postSingin({
        success: resolve,
        commit
      }, { activityId, signUpId, body })
    }).then(() => {
      commit(mTypes.SET_LOADING, { key: aTypes.ACTIVITY_POST_SIGNIN, loading: false })
    })
  },
  [aTypes.ACTIVITY_POST_SIGNOUT] ({ commit }, { activityId, signUpId, body }) {
    return new Promise((resolve) => {
      commit(mTypes.SET_LOADING, { key: aTypes.ACTIVITY_POST_SIGNOUT, loading: true })
      api.activity.postSingout({
        success: resolve,
        commit
      }, { activityId, signUpId, body })
    }).then(() => {
      commit(mTypes.SET_LOADING, { key: aTypes.ACTIVITY_POST_SIGNOUT, loading: false })
    })
  },
  [aTypes.ACTIVITY_POST_CANCEL_SIGNIN] ({ commit }, { activityId, signUpId, signInId }) {
    return new Promise(resolve => {
      commit(mTypes.SET_LOADING, { key: aTypes.ACTIVITY_POST_CANCEL_SIGNIN, loading: true })
      api.activity.deleteSignIn({
        success: resolve,
        commit
      }, { activityId, signUpId, signInId })
    }).then(() => {
      commit(mTypes.SET_LOADING, { key: aTypes.ACTIVITY_POST_CANCEL_SIGNIN, loading: false })
    })
  }
}

const mutations = {
  [mTypes.ACTIVITY_SET_SIGN_UP] (state, payload) {
    state = payload
  },
  [mTypes.ACTIVITY_SET_SIGN_UP_TICKETS] (state, payload) {
    state.tickets = payload
  },
  [mTypes.ACTIVITY_SET_SIGN_UP_SESSION_TIME] (state, payload) {
    state.sessionTimes = payload
  },
  [mTypes.ACTIVITY_SET_SIGN_UP_FORM_DATA] (state, payload) {
    state.formData = payload
  }
  // [mTypes.ACTIVITY_RESET_SIGN_UP] (state) {
  //   // state.notFound = null
  //   state.loaded = false
  //   // state.id = ''
  //   // state.name = ''
  //   // state.mobile = ''
  //   // state.tickets = []
  //   // state.sessionTimes = []
  //   // state.formData = []
  // }
}

const getters = {
  hasMultiSessionTimes: state => {
    return state.sessionTimes.length > 1
  }
}

export default {
  state,
  actions,
  getters,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/activity/signUp.js